import type { Claim } from '@/types/claim'
import type { RequestState } from '@/utils/restStore'
import { handleRequest, initialRequestState } from '@/utils/restStore'
import { defineStore } from 'pinia'

import Api from '@/services/api'

interface State {
  claim: RequestState<Claim>
}

const initialState = (): State => ({
  claim: initialRequestState()
})

export const useClaimStore = defineStore({
  id: 'claim',
  state: initialState,
  actions: {
    async fetchClaim(uuid: String) {
      await handleRequest(
        () => Api.getClaim(uuid),
        (claim: RequestState<Claim>) => {
          this.claim = claim
        }
      )
    }
  }
})
